"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionGrantArguments = exports.PermissionGrantOptions = void 0;
exports.PermissionGrantOptions = [
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the Microsoft Teams app manifest template file path, it can be either absolute path or relative path to project root folder, defaults to './appPackage/manifest.json'",
        default: "./appPackage/manifest.json",
    },
    {
        name: "env",
        type: "string",
        description: "Specifies the environment name for the project.",
    },
    {
        name: "aad-manifest-file",
        questionName: "manifest-file-path",
        type: "string",
        shortName: "a",
        description: "Specifies the Microsoft Entra app manifest file path, can be either absolute path or relative path to project root folder.",
        default: "./aad.manifest.json",
    },
    {
        name: "email",
        type: "string",
        description: "Email address of the collaborator.",
    },
];
exports.PermissionGrantArguments = [];
//# sourceMappingURL=PermissionGrantOptions.js.map